import React, { useEffect, useState } from "react";
import PageContainer from "../../components/PageContainer/PageContainer";
import styles from "./MaterialsTracking.module.css";
import t from "../../utils/translation";
import FilterDate from "../../components/FilterDate/FilterDate";
import TableContainerQ from "../../components/TableBionovaQ/TableContainerQ/TableContainerQ";
import TableHeadQ from "../../components/TableBionovaQ/TableHeadQ/TableHeadQ";
import TableHeaderCellQ from "../../components/TableBionovaQ/TableHeaderCellQ/TableHeaderCellQ";
import SpinnerQ from "../../components/SpinnerQ/SpinnerQ";
import TableBodyQ from "../../components/TableBionovaQ/TableBodyQ/TableBodyQ";
import TableRowQ from "../../components/TableBionovaQ/TableRowQ/TableRowQ";
import TableRowCellQ from "../../components/TableBionovaQ/TableRowCellQ/TableRowCellQ";
import TruncatedText from "../../components/TableBionovaQ/TruncatedText/TruncatedText";
import TablePaginationQ from "../../components/TableBionovaQ/TablePaginationQ/TablePaginationQ";
import useTableQ from "../../utils/Hooks/useTableQ";
import df from "../../utils/dateFormater";
import SelectSearch from "../../components/FormComponents/SelectSearch/SelectSearch";
import request from "../../utils/request";
import { getRegionalFormat } from "../../utils/sessionHandler";
import parseFiltersDate from "../../utils/parseFiltersDate";
import SelectQ from "../../components/FormComponents/SelectQ/SelectQ";
import Redirect from "../../utils/Redirect";

const MaterialsTracking = () => {
  const [materials, setMaterials] = useState([]);
  const [operators, setOperators] = useState([]);
  const [actions, setActions] = useState([]);

  const [selectedMaterial, setSelectedMaterial] = useState("");
  const [inputMaterial, setInputMaterial] = useState("");

  const [filters, setFilters] = useState({
    dateFrom: "",
    dateTo: "",
    operator: "",
    action: "",
  });

  const [tracking, setTracking] = useState([]);
  const [totalPages, setTotalPages] = useState(1);
  const [loading, setLoading] = useState(false);

  const columns = [
    "actionDate",
    "materialName",
    "serialNumber",
    "quantity",
    "chargeWashingCycle",
    "washerName",
    "hygieneMonitoringPackageNumber",
    "packageNumber",
    "cycleNumber",
    "sterilizerName",
    "username",
    "movement",
  ];

  const columnsHeader = [
    { key: "actionDate", label: t("dateSpan") || "Date" },
    { key: "materialName", label: t("BlankEntry81") || "Material" }, //MaterialNameSpan
    { key: "serialNumber", label: t("SerialNumberSpan") || "Serial" },
    { key: "quantity", label: t("QuantitySpan") || "Quantity" },
    { key: "chargeWashingCycle", label: t("BlankEntry80") || "Washing Cycle" }, // Wash Cycle Number
    { key: "washerName", label: t("WasherSpan") || "Washer" },
    { key: "hygieneMonitoringPackageNumber", label: t("BlankEntry79") || "Hygiene Monitoring Package Number" },
    { key: "packageNumber", label: t("BlankEntry82") || "Package" }, //PackageNumberSpan
    { key: "cycleNumber", label: t("BlankEntry83") || "Cycle" }, // Sterilization Cycle Number
    { key: "sterilizerName", label: t("SterilizerSpan") || "Sterilizer" },
    { key: "username", label: t("UserSpan") || "Operator" },
    { key: "movement", label: t("MovementSpan") || "Movements" },
  ];

  const {
    currentPage,
    currentItems,
    itemsPerPage,
    handleChangePage,
    handleChangeItemsPerPage,
    handleSortByColumn,
    setCurrentPage,
  } = useTableQ(tracking, columns, totalPages);

  const handleDateChange = (type, value) => {
    setFilters((prev) => {
      if (type === "clear") {
        return { ...prev, dateFrom: "", dateTo: "" };
      } else if (type === "dateTo") {
        return { ...prev, dateTo: value };
      } else {
        return { ...prev, dateFrom: value };
      }
    });
  };

  const handleSelectedMaterial = (material) => {
    setSelectedMaterial(material);
  };

  const handleInputMaterial = (e) => {
    setInputMaterial(e.target.value);
  };

  const handleSelectOperator = (e) => {
    const { value } = e.target;

    setFilters((prev) => ({ ...prev, operator: value }));
  };

  const handleSelectAction = (e) => {
    const { value } = e.target;

    setFilters((prev) => ({ ...prev, action: value }));
  };

  const getMaterials = async () => {
    try {
      let res = await request().get("/api/parameter/material");
      setMaterials(res.data.materials);
      setActions(
        res.data.actionCodes.map((a) => ({
          value: a.actionCode,
          name: a.codeName,
        }))
      );
      setOperators(
        res.data.users.map((o) => ({ value: o.userId, name: o.username }))
      );
    } catch (error) {
      console.error("Error fetching materials:", error);
    }
  };

  const getTracking = async () => {
    if (!selectedMaterial?.materialId) return;
    setLoading(true);

    try {
      const { dateFrom, dateTo, operator, action } = filters;
      const dateFromParsed = parseFiltersDate(
        df(dateFrom, "date"),
        getRegionalFormat().dateFormat
      );
      const dateToParsed = parseFiltersDate(
        df(dateTo, "date"),
        getRegionalFormat().dateFormat,
        true
      );

      let res = await request().get(
        `/api/materialtracker/list?includeCount=true&pageSize=${itemsPerPage}&page=${currentPage}&materialId=${selectedMaterial.materialId}&userId=${operator}&actionCode=${action}&from=${dateFromParsed}&to=${dateToParsed}`
      );
      setTracking(res.data.materialTrackListatorList);
      setTotalPages(res.data.totalPages);
    } catch (error) {
      console.error("Error fetching tracking:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleDetail = (id,item) => {
    if (!id) return;
    const path = item.actionCode === 202 ? `/appcycledetail/${id}` : `/appcyclewashdetail/${id}`;

    Redirect({
      redirect: true,
      path: path,
      parameters: { materialRecord: true },
    });
  };

  useEffect(() => {
    if (!selectedMaterial) return;
    getTracking();
  }, [filters, selectedMaterial,currentPage, itemsPerPage]);

  useEffect(() => {
    getMaterials();
  }, []);
  return (
    <PageContainer
      category={"Reports"}
      categoryId={"Reports"}
      backUrl="/appmain"
      title={"Material Tracking"}
    >
      <div className={styles.container}>
        <div className={styles.tableContainer}>
          <div className={styles.headerContainer}>
            <div>
              <div className={styles.filterContainer}>
                <div className={styles.filter}>
                  <SelectSearch
                    handleInputChange={handleInputMaterial}
                    value={inputMaterial}
                    placeholder={"Select Material"}
                    name={"material"}
                    options={materials}
                    onOptionSelect={handleSelectedMaterial}
                    idProp={"materialId"}
                    labelProp={"materialName"}
                  />
                </div>
                <div className={styles.filter}>
                  <FilterDate
                    handleChange={handleDateChange}
                    dateTo={filters.dateTo}
                    dateFrom={filters.dateFrom}
                    disabled={!selectedMaterial}
                  />
                </div>
              </div>
              <div className={styles.filterContainer}>
                <div className={styles.filter}>
                  <SelectQ
                    placeholder={t("OperatorSpan")}
                    hasPlaceholder={true}
                    options={operators}
                    handleSelect={handleSelectOperator}
                    selectValue={filters.operator}
                    containerWidth={"100%"}
                    disabled={!selectedMaterial}
                  />
                </div>
                <div className={styles.filter}>
                  <SelectQ
                    placeholder={t("MovementSpan") || "Movements"}
                    hasPlaceholder={true}
                    options={actions}
                    handleSelect={handleSelectAction}
                    selectValue={filters.action}
                    containerWidth={"100%"}
                    disabled={!selectedMaterial}
                  />
                </div>
              </div>
            </div>

            {selectedMaterial && <div className={styles.materialCard}>
              <div className={styles.cardHeader}>
                {selectedMaterial.materialName || "Material"}
              </div>
              <div className={styles.columnsContainer}>
                <div className={styles.columnsCard}>
                  <div className={styles.fieldRow}>
                    <span className={styles.fieldLabel}>Type:</span>
                    <span className={styles.fieldValue}>
                      {selectedMaterial.materialType}
                    </span>
                  </div>

                  <div className={styles.fieldRow}>
                    <span className={styles.fieldLabel}>Serial:</span>
                    <span className={styles.fieldValue}>
                      {selectedMaterial.serialNumber || "N/A"}
                    </span>
                  </div>

                  <div className={styles.fieldRow}>
                    <span className={styles.fieldLabel}>Cycles:</span>
                    <span className={styles.fieldValue}>
                      {selectedMaterial.cycleNumber}
                    </span>
                  </div>
                </div>
                <div className={styles.columnsCard}>
                  <div className={styles.fieldRow}>
                    <span className={styles.fieldLabel}>Implant:</span>
                    <span className={styles.fieldValue}>
                      {selectedMaterial.implant ? "Yes" : "No"}
                    </span>
                  </div>

                  <div className={styles.fieldRow}>
                    <span className={styles.fieldLabel}>Endoscopy:</span>
                    <span className={styles.fieldValue}>
                      {selectedMaterial.endoscopy ? "Yes" : "No"}
                    </span>
                  </div>

                  <div className={styles.fieldRow}>
                    <span className={styles.fieldLabel}>
                      Compatible Method:
                    </span>
                    <span className={styles.fieldValue}>
                      {selectedMaterial.compatibleMethod}
                    </span>
                  </div>
                </div>
              </div>
            </div>}
          </div>
          <TableContainerQ>
            <TableHeadQ>
              {columnsHeader.map((col) => (
                <TableHeaderCellQ
                  key={col.key}
                  handleClick={() => handleSortByColumn(col.key)}
                >
                  {col.label}
                </TableHeaderCellQ>
              ))}
            </TableHeadQ>
            {loading ? (
              <div className="spinnerContainer">
                <SpinnerQ />
              </div>
            ) : (
              <TableBodyQ withoutPagination={true}>
                {currentItems.map((item, rowIndex) => (
                  <TableRowQ 
                  key={rowIndex}
                  actions={true}
                  onClick={() => handleDetail(item.actionCode === 202 ? item.chargeId : item.actionCode === 302 ? item.chargeWashingId : null,item)}
                  >
                    {columns.map((col) => {
                      const isDateColumn = col.toLowerCase().includes("date");
                      const value = isDateColumn
                        ? df(item[col], "dateTime")
                        : String(item[col] ?? "");
                      return (
                        <TableRowCellQ key={col}>
                          <TruncatedText text={value} maxLength={25} />
                        </TableRowCellQ>
                      );
                    })}
                  </TableRowQ>
                ))}
              </TableBodyQ>
            )}
            <TablePaginationQ
              handleChangePage={handleChangePage}
              handleChangeItemsPerPage={handleChangeItemsPerPage}
              currentPage={currentPage}
              totalPages={totalPages}
              setCurrentPage={setCurrentPage}
            />
          </TableContainerQ>
        </div>
      </div>
    </PageContainer>
  );
};

export default MaterialsTracking;
